import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { ArticlesViewComponent } from '../../../../Components/articles-view/articles-view.component';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BaseComponent } from '../../../base.component';
import { IPopup } from '../../../../Components/popup/popup.model';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../constants';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-scouts',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    ArticlesViewComponent,
    PageheaderComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './scouts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoutsComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'activities', path: '/activities' },
    children: [{ title: 'scouts_mej', path: null }],
  };

  public scoutsArticlesArray: IPopup[] = [];
  public mejArticlesArray: IPopup[] = [];

  public scoutsStart: number = 1;
  public scoutsLimit: number = 5;
  public scoutsTotalcount: number;

  public mejStart: number = 1;
  public mejLimit: number = 5;
  public mejTotalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
  }

  ngOnInit(): void {
    this.onScoutPaginateEvent(0);
    this.onMejPaginateEvent(0);
  }

  onScoutPaginateEvent($event: number) {
    this.scoutsStart = $event;
    this.articleType = NATIONAL_PAGES.ACTIVITIES.SCOUTS.SCOUT;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.scoutsStart,
        limit: this.scoutsLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.scoutsTotalcount = data.payload?.count || 0;
          this.scoutsArticlesArray = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  onMejPaginateEvent($event: number) {
    this.mejStart = $event;
    this.articleType = this.articleType = NATIONAL_PAGES.ACTIVITIES.SCOUTS.MEJ;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.mejStart,
        limit: this.mejLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.mejTotalcount = data.payload?.count || 0;
          this.mejArticlesArray = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
